import React, { useState } from "react";
import "./Accordion.scss";
import minusIcon from "../../images/minus.svg";
import plusIcon from "../../images/plus.svg";
import { useStoreActions } from "easy-peasy";
import Collapse from "@material-ui/core/Collapse";
import * as conf from "../../../config";

const Accordion = ({ title, type, data, doc, downloadCard }) => {
  const [clicked, setClicked] = useState(false);
  const setPopup = useStoreActions((actions) => actions.something.setPopup);

  const download = (event) => {
    if (doc) {
      window.open(conf.API_HOST + doc, "_blank");
    }
  };

  const downloadFile = (e) => {
    e.stopPropagation();
    window.open(conf.API_HOST + downloadCard, "_blank");
  };

  return (
    <div className="accordionContainer">
      <div className="accordion">
        <div className="accordionItem">
          <div className="accordionHeader" onClick={() => setClicked(!clicked)}>
            <span>{title}</span>
            <div className="icon">
              {downloadCard && (
                <span
                  className="material-icons download"
                  onClick={downloadFile}
                >
                  file_download
                </span>
              )}
              <div
                className="iconItself"
                style={{
                  backgroundImage: `url(${clicked ? minusIcon : plusIcon})`,
                }}
              ></div>
            </div>
          </div>
          <Collapse in={clicked}>
            <div className="itemsContainer">
              {type < 3 &&
                data.map((el, index) => (
                  <React.Fragment key={index}>
                    {type == 1 && (
                      <div className="mainItem">
                        <div className="item">{el.title}</div>
                        <div className="item">{el.value}</div>
                      </div>
                    )}
                    {type == 2 && (
                      <div className="item" onClick={() => setPopup(el)}>
                        {el.title}
                      </div>
                    )}
                  </React.Fragment>
                ))}
              {type == 3 && (
                <div
                  className="text ql-editor"
                  dangerouslySetInnerHTML={{ __html: data }}
                  onClick={(event) => download(event)}
                ></div>
              )}
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
